import React from 'react';
import styles from '../../../styles/index.module.scss';

/**
 * 一组可选的小标签（单选）
 * @param {Array<{ value, label, hint?, icon? }>} options
 */
export const ChipGroup = ({ options, value, onChange, disabled = false, size = 'default' }) => {
    return (
        <div className={`${styles.chipRow} ${size === 'large' ? styles.chipRowLarge : ''}`}>
            {options.map((opt) => {
                const selected = opt.value === value;
                return (
                    <button
                        type="button"
                        key={opt.value}
                        className={`${styles.chip} ${selected ? styles.chipSelected : ''}`}
                        onClick={() => !disabled && onChange(opt.value)}
                        disabled={disabled}
                        aria-pressed={selected}
                    >
                        {opt.icon && <span className={styles.chipIcon}>{opt.icon}</span>}
                        <span>{opt.label}</span>
                        {opt.hint && <span className={styles.chipHint}>{opt.hint}</span>}
                    </button>
                );
            })}
        </div>
    );
};

export default ChipGroup;
